import type { JiraEpicSyncStatus, JiraItemSyncStatus, JiraStoriesSyncStatus } from '@/domain/models/development.js';
import { JiraRetryBanner } from '@/presentation/pages/developments/development-detail/components/jira-retry-banner.js';

interface Props {
    lastError: string | null;
    epicStatus: JiraEpicSyncStatus;
    storiesStatus: JiraStoriesSyncStatus;
    solicitationStatuses: JiraItemSyncStatus[];
    retryLabel: string;
    onRetry?: () => void;
    retrying: boolean;
}

const isFailure = (status: string): boolean => {
    return status === 'FAILED' || status === 'RETRYING';
};

export function JiraSyncFailureBanner({ lastError, epicStatus, storiesStatus, solicitationStatuses, retryLabel, onRetry, retrying }: Props) {
    const failed = isFailure(epicStatus) || isFailure(storiesStatus) || solicitationStatuses.some(isFailure);
    return <JiraRetryBanner message={failed ? lastError : null} retryLabel={retryLabel} onRetry={onRetry} retrying={retrying} />;
}
